import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const PlayIcon = (props?: SvgProps) => (
  <svg
    height="20"
    width="20"
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M4.16602 4.1576C4.16602 3.3483 4.16602 2.94365 4.33476 2.72059C4.48176 2.52626 4.70645 2.40601 4.94968 2.39149C5.22888 2.37482 5.56557 2.59928 6.23895 3.0482L15.0019 8.89018C15.5583 9.26111 15.8365 9.44658 15.9335 9.68035C16.0182 9.88473 16.0182 10.1144 15.9335 10.3188C15.8365 10.5526 15.5583 10.738 15.0019 11.109L6.23895 16.951C5.56557 17.3999 5.22888 17.6243 4.94968 17.6077C4.70645 17.5931 4.48176 17.4729 4.33476 17.2786C4.16602 17.0555 4.16602 16.6509 4.16602 15.8416V4.1576Z"
      stroke="#19191B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
)
